import React from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/styles'

import { LoadingContent } from 'dialogs'
import { ValidationResultButton } from 'components/buttons'
import { updateEntity } from 'utils/updateEntity'
import { format } from 'utils/stringUtilities'
import { DialogBase, dialogSizes } from 'dialogs/dialogBase'
import { styles } from './detailDialog.css'
export const createDetailDialog = ({ metadata, actionCreators, Form }) => {
  return connect(
    (state) => ({ [metadata.page]: state[metadata.page] }),
    {
      get: actionCreators.get,
      update: actionCreators.update,
      save: actionCreators.save,
      saveAll: actionCreators.saveAll,
      ...actionCreators.additionalActions
    }
  )(withStyles(styles)(class GenericDetailDialog extends DialogBase {
    componentDidMount () {
      this.props.get({ id: this.props.context.entity.id })
    }
    isLoading = () => this.props[metadata.page].fetching || this.props[metadata.page].entity === null
    isSaving = () => this.props[metadata.page].saving
    selectedIds = () => this.props.context.selectedIds || []
    modalClassName () { return `${this.props.className || ''} ${this.isMassEdit() ? 'multi-edit' : ''}` }
    isMassEdit = () => this.selectedIds().length > 1
    isDirty = () => this.props[metadata.page].entity === null || this.props[metadata.page].entity.isDirty
    save = () => {
      const entityDto = this.props[metadata.page].entity
      if (this.selectedIds().length > 1) {
        this.props.saveAll({ entityDto, selectedIds: this.selectedIds() }, () => {
          if (typeof this.props.context.onSaved === 'function') { this.props.context.onSaved()}
          this.close()
        })
      } else {
        this.props.save(entityDto, (createdEntity) => {
          if (typeof this.props.context.onSaved === 'function') { this.props.context.onSaved({ entity: createdEntity, index: -1})}
          this.close()
        })
      }
    }
    modalTitle () {
      const title = this.props.localize(`${metadata.page}.detailTitle`)
      if (this.selectedIds().length > 1) {
        return format(this.props.localize('common.massEditFormat'), title, this.selectedIds().length)
      }
      return title
    }
    modalSize () { return metadata.dialogSize || dialogSizes.XL }

    modalButtons () { return <ValidationResultButton isLoading={this.isSaving()} disabled={!this.isDirty() || this.isLoading() || this.isSaving()} onClick={this.save} /> }
    modalBody () {
      if (this.isLoading()) { return <LoadingContent /> }
      return (
        <div className={this.props.classes.root}>
          <Form
            {...this.props}
            data={this.props[metadata.page]}
            updateEntity={propName => updateEntity(propName, this.props)}
            isInDialog
          />
        </div>
      )
    }
  }))
}

